<template>
  <div>
    <a
      v-if="scopeDetail"
      id="exportJSON"
      @click="exportJson"
      class="ag-button sm border-0 ag-button_primary ag-button_radius ml-2"
      >Export JSON</a
    >
    <json-view-item
      :class="[{ 'root-item': true, dark: colorScheme === 'dark' }]"
      :data="scopeDetail"
      style="width:80%; margin-left:10%"
      v-if="scopeDetail"
      :maxDepth="3"
      :canSelect="hasSelectedListener"
      :collapse-open="true"
    />
    <div v-else>Cannot find any scope details for selected item</div>
  </div>
</template>
<script>
import JsonViewItem from "../ag-xml-detail/components/JsonView.vue";

export default {
  name: "ag-scope-detail",
  data() {
    return {
      scopeDetail: null,
    };
  },
  methods: {
    exportJson() {
      var elem = document.querySelector("#exportJSON");
      if (elem) {
        var data =
          "text/json;charset=utf-8," +
          encodeURIComponent(JSON.stringify(this.scopeDetail));
        elem.setAttribute("href", "data:" + data);
        elem.setAttribute("download", "data.json");
      }
    },
  },
  components: {
    JsonViewItem,
  },
  computed: {
    hasSelectedListener() {
      return Boolean(this.$attrs && this.$attrs.selected);
    },
  },
  mounted() {
    if (localStorage.getItem("scopeDetail")) {
      try {
        this.scopeDetail = JSON.parse(localStorage.getItem("scopeDetail"));
      } catch (err) {
        console.log(err);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
#exportJSON {
  margin-left: 0 !important;
  margin-bottom: 1.5rem;
  padding: 5px 10px;
  display: inline-block;
}

.ag-scopedetail {
  height: 60vh;
  overflow: auto;
}
.vjs-tree {
  font-size: 13px;
}
</style>
